import {
  LOGIN_LOGIN_ACTIONS_BEGIN,
  LOGIN_LOGIN_ACTIONS_SUCCESS,
  LOGIN_LOGIN_ACTIONS_FAILURE,
  LOGIN_LOGIN_ACTIONS_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
import { push } from 'react-router-redux'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function loginActions(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: LOGIN_LOGIN_ACTIONS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      request({
        url: '/auth/login',
        method: 'post',
        data: args
      }).then(
        (res) => {
          console.log('11111111111111111111111111111111111111111111111111111111111111111111115325')
          console.log(res)
          if (res.status == 400) {
            dispatch({
              type: LOGIN_LOGIN_ACTIONS_FAILURE,
              data: { error: res.data.message },
            });
            reject(res.data.message);
          } else {
            // token 保存
            sessionStorage.setItem('token', res.token)
            // userinfo 保存
            sessionStorage.setItem('user', JSON.stringify(res.user.user))
            sessionStorage.setItem('menu', JSON.stringify(
              [
                { "id": 37, "name": "基础数据", "icon": "", "route": "/user", "showMenu": true, "orderNum": 991 },
                { "id": 51, "name": "单位信息", "icon": "", "route": "/user/companyMessage", "menuParentId": 37, "breadcrumbParentId": 37, "showMenu": true, "orderNum": 97 },
                { "id": 38, "name": "制造资质", "icon": "", "route": "/user/Frui_zzzzPage", "menuParentId": 37, "breadcrumbParentId": 37, "showMenu": true, "orderNum": 98 },
                { "id": 53, "name": "气瓶附件", "icon": "", "route": "/user/Frui_qpfjPage", "menuParentId": 37, "breadcrumbParentId": 37, "showMenu": true, "orderNum": 96 },
                { "id": 54, "name": "气瓶标准", "icon": "", "route": "/user/Frui_pfbzPage", "menuParentId": 37, "breadcrumbParentId": 37, "showMenu": true, "orderNum": 95 },
                { "id": 55, "name": "气瓶品种", "icon": "", "route": "/user/Frui_qppzPage", "menuParentId": 37, "breadcrumbParentId": 37, "showMenu": true, "orderNum": 94 },
                { "id": 56, "name": "气瓶型号", "icon": "", "route": "/user/Frui_pfxhPage", "menuParentId": 37, "breadcrumbParentId": 37, "showMenu": true, "orderNum": 93 },
                { "id": 57, "name": "模板文件", "icon": "", "route": "/user/tempfile", "menuParentId": 37, "breadcrumbParentId": 37, "showMenu": true, "orderNum": 93 },
                { "id": 59, "name": "气瓶产品", "icon": "", "route": "/product/lng", "showMenu": true, "orderNum": 900 },
                { "id": 42, "name": "计划批次", "icon": "", "route": "/plan/lng", "showMenu": true, "orderNum": 800 },
                    ]
            ))

            dispatch(push("/user/companyMessage"));
            dispatch({
              type: LOGIN_LOGIN_ACTIONS_SUCCESS,
              data: res,
            });
            resolve(res);
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: LOGIN_LOGIN_ACTIONS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissLoginActionsError() {
  return {
    type: LOGIN_LOGIN_ACTIONS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_LOGIN_ACTIONS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        loginActionsPending: true,
        loginActionsError: null,
      };

    case LOGIN_LOGIN_ACTIONS_SUCCESS:
      // The request is success
      return {
        ...state,
        loginActionsPending: false,
        loginActionsError: null,
      };

    case LOGIN_LOGIN_ACTIONS_FAILURE:
      // The request is failed
      return {
        ...state,
        loginActionsPending: false,
        loginActionsError: action.data.error,
      };

    case LOGIN_LOGIN_ACTIONS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        loginActionsError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/login/redux/loginActions.js